import { Typography, styled } from "@mui/material";

export const BaseCell = styled(Typography)(({ theme }) => ({
  height: "15px",
  border: `0.1px solid ${theme.palette.darkGray.main}`
}));
